import { render, staticRenderFns } from "./PlaceSchool.vue?vue&type=template&id=2ac73651&scoped=true&"
import script from "./PlaceSchool.vue?vue&type=script&lang=js&"
export * from "./PlaceSchool.vue?vue&type=script&lang=js&"
import style0 from "./PlaceSchool.vue?vue&type=style&index=0&id=2ac73651&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac73651",
  null
  
)

export default component.exports